import React from "react";
import ArticleSearchContainer from "../../../containers/ArticleSearchContainer";
import PortalPCSortTabs from "./PortalPCSortTabs";
import { RESULTS_PER_PAGE } from "../../../../utils/search";

function PortalPCResultBar() {
  const { page, total } = ArticleSearchContainer.useContainer();
  const currentPage = page || 1;
  const start = currentPage > 1 ? (currentPage - 1) * RESULTS_PER_PAGE + 1 : 1;
  const end = Math.min(currentPage * RESULTS_PER_PAGE, total);

  return (
    <div className="portalPcResultBar">
      <p className="portalPcResultCount" role="status" aria-live="polite">
        {total > 0 && start <= end && (
          <>
            <strong>{total}</strong>件中 / {start}-{end}件を表示
          </>
        )}
      </p>
      <PortalPCSortTabs />
    </div>
  );
}

export default PortalPCResultBar;
